var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var CaptchaStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  .error-msg {\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: ", ";\n  }\n"], ["\n  display: block;\n  .error-msg {\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.generalContent.text.danger.color;
});
var templateObject_1;
//# sourceMappingURL=CaptchaStyled.js.map